import { get, post, getToken } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL + "/partner-files";

const createPartnerFile = (client) => post(url + `/create`, { ...client });

const getPartnerFileHeader = (documentId, siteId) => get(`${url}/${documentId}/${siteId}/header`);

const computePartnerFileNextStates = (documentId, siteId) => post(`${url}/${documentId}/${siteId}/states/compute`);

const updatePartnerFileState = (documentId, siteId, stateId, comment, reasonsIds) =>
  post(`${url}/${documentId}/${siteId}/state`, { documentId, siteId, stateId, comment, selectedReasons: reasonsIds });

const getPartnerFiles = filters => get(url + "?" + filters);

const getVisibilityLevels = () => get(`${url}/visibility-levels`);

const loadUserPreferences = () => get(`${url}/user-preferences`);

const updateUserPreferences = userPreferences => {
  let newUserPreferences = userPreferences.reduce((items, item) => {
    if (!item.isDefault) {
      const newItem = { filterName: item.filterName, preferenceValue: JSON.stringify(item) };
      items.push(newItem);
    }
    return items;
  }, []);

  return post(`${url}/update-user-preferences`, { userPreferences: newUserPreferences });
};

const exportPartnerFiles = (filters, fieldsToShow) => post(`${url}/export-list`, { ...filters, fieldsToShow });

const buildPartnerFileExportDownloadUrl = (filePath, fileName) => {
  return `${url}/download/${encodeURIComponent(filePath)}/${encodeURIComponent(fileName)}?access_token=${getToken()}`;
};

const exp = {
  createPartnerFile,
  getPartnerFileHeader,
  computePartnerFileNextStates,
  updatePartnerFileState,
  getPartnerFiles,
  getVisibilityLevels,
  loadUserPreferences,
  updateUserPreferences,
  exportPartnerFiles,
  buildPartnerFileExportDownloadUrl
};
export default exp;
